let get_delTags = function() {
	if (Object.keys(this.get_delTags).length > 0) {
		this.dashDelTag(this.get_delTags);
	}
};
export default get_delTags;
